import React from "react";
import { MoreVertical } from "lucide-react";
import ServiceDropdown from "./ServiceDropdown";
import clsx from "clsx";

const ServiceCard = ({
  srv,
  color,
  openMenu,
  setOpenMenu,
  onDeleted,
  onDuplicated,
}) => {
  const handleMenuToggle = () => {
    setOpenMenu(openMenu === srv.title ? null : srv.title);
  };

  return (
    <div
      className="flex items-center justify-between bg-dry border border-border rounded-lg px-3 py-2 shadow-sm hover:shadow-md transition relative"
      style={{ borderLeft: `8px solid ${color}` }} // 👈 only left border uses HEX
    >
      <div className="gap-1 flex flex-col">
        <h4 className="font-medium">{srv.title}</h4>
        <p className="text-xs text-gray-500">{srv.description}</p>
        <p className="text-xs text-gray-400">{srv.desc}</p>
      </div>
      <div className="flex items-center gap-3 relative">
        <p className="text-sm font-semibold">NZ${srv.price}</p>
        <button
          onClick={handleMenuToggle}
          className="p-1 rounded-full hover:bg-gray-100"
        >
          <MoreVertical className="w-5 h-5 text-gray-500" />
        </button>

        {openMenu === srv.title && (
          <ServiceDropdown
            serviceId={srv._id}
            onClose={() => setOpenMenu(null)}
            onDeleted={onDeleted}
            onDuplicated={(newService) => {
              // pass up to parent
              if (typeof onDuplicated === "function") {
                onDuplicated(newService);
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ServiceCard;
